import React from 'react'
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import SalesFilter from './containers/SalesFilter'
import SalesList from './containers/SalesList'

const mapStateToProps = state => {  
  return {    
    isLogged: state.user.isLogged,
    //agentLogin: state.user.agentLogin,      
  }
}

class Sales extends React.Component{
  
  render() {
    if (!this.props.isLogged)
      return <Redirect to='/'/>;
      
    return this.renderReport()
  }
  renderReport(){
    return (
      <div>             
        <SalesFilter/>
        <SalesList />
      </div>
    )
  }
}
export default connect(
  mapStateToProps,
  //mapDispatchToProps
)(Sales)


// WEBPACK FOOTER //
// ./src/Sales.js